<template>
  <Card
    title="Education Info"
    direction="column"
    color="background"
    background="light-dark"
  >
    <TextComponent color="background" type="paragraph" as="p">
      School: {{ data.hackerApplication.school }}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Program: {{ data.hackerApplication.program }}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Level of Study: {{ data.hackerApplication.levelOfStudy }}
    </TextComponent>
  </Card>
</template>

<script>
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import Card from '../../../../containers/Card';

  export default {
  name: 'EducationInfo',
  components: {
    TextComponent,
    Card,
  },
  props: {
    data: Object,
  },
};
</script>
